import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizationGuard } from './authorization-guard';
import { GraficoComponent } from './home/Components/grafico.component';
import { FaqEmmasaComponent } from './home/Faqs/faqEmmasa.component';
import { FaqGuadalaguaComponent } from './home/Faqs/faqGuadalagua.component';
import { FaqSoriaComponent } from './home/Faqs/faqSoria.component';
import { FaqValorizaComponent } from './home/Faqs/faqValoriza.component';
import { AveriasComponent } from './home/averias.component';
import { BajaComponent } from './home/baja.component';
import { ChangePasswordComponent } from './home/changePassword.component';
import { ConsumofacturaComponent } from './home/consumofactura.component';
import { ContactComponent } from './home/contact.component';
import { DatosCorrespondenciaComponent } from './home/datoscorrespondencia.component';
import { DomiciliacionFacturaComponent } from './home/domiciliacionFactura.component';
import { FaqComponent } from './home/faq.component';
import { HomeComponent } from './home/home.component';
import { LecturaContadorComponent } from './home/lecturacontador.component';
import { SimuladorConsumoComponent } from './home/simuladorConsumo.component';
import { UsuarioComponent } from './home/usuario.component';
import { ContactpublicComponent } from './public/contactpublic.component';
import { LoginComponent } from './public/login.component';
import { RegisterComponent } from './public/register.component';
import { ResetPasswordComponent } from './public/resetPassword.component';

export const routes: Routes = [
  { path: 'public/login', component: LoginComponent },
  { path: 'home/home', component: HomeComponent, pathMatch: 'full', canActivate: [AuthorizationGuard] },
  { path: 'home/contact', component: ContactComponent, pathMatch: 'full', canActivate: [AuthorizationGuard] },
  { path: 'public/register', component: RegisterComponent },
  { path: 'home/datoscorrespondencia', component: DatosCorrespondenciaComponent, pathMatch: 'full', canActivate: [AuthorizationGuard] },
  { path: 'home/consumofactura', component: ConsumofacturaComponent, pathMatch: 'full', canActivate: [AuthorizationGuard] },
  { path: 'home/lecturacontador', component: LecturaContadorComponent, pathMatch: 'full', canActivate: [AuthorizationGuard] },
  { path: 'home/faq', component: FaqComponent, pathMatch: 'full', canActivate: [AuthorizationGuard] },
  { path: 'home/faqValoriza', component: FaqValorizaComponent, pathMatch: 'full', canActivate: [AuthorizationGuard] },
  { path: 'home/faqSoria', component: FaqSoriaComponent, pathMatch: 'full', canActivate: [AuthorizationGuard] },
  { path: 'home/faqGuadalagua', component: FaqGuadalaguaComponent, pathMatch: 'full', canActivate: [AuthorizationGuard] },
  { path: 'home/faqEmmasa', component: FaqEmmasaComponent, pathMatch: 'full', canActivate: [AuthorizationGuard] },
  { path: 'home/changePassword', component: ChangePasswordComponent, pathMatch: 'full' },
  { path: 'public/resetPassword', component: ResetPasswordComponent },
  { path: 'home/domiciliacionFactura', component: DomiciliacionFacturaComponent, pathMatch: 'full', canActivate: [AuthorizationGuard] },
  { path: 'home/usuario', component: UsuarioComponent, pathMatch: 'full', canActivate: [AuthorizationGuard] },
  { path: 'home/simuladorConsumo', component: SimuladorConsumoComponent, pathMatch: 'full', canActivate: [AuthorizationGuard] },
  { path: 'home/grafico', component: GraficoComponent, pathMatch: 'full', canActivate: [AuthorizationGuard] },
  { path: 'home/averias', component: AveriasComponent, pathMatch: 'full', canActivate: [AuthorizationGuard] },
  { path: 'home/baja', component: BajaComponent, pathMatch: 'full', canActivate: [AuthorizationGuard] },
  { path: 'public/contactpublic', component: ContactpublicComponent },
  { path: '', redirectTo: '/', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
